import { render } from "./AgencyCompTab.vue?vue&type=template&id=48f8f36b"
import script from "./AgencyCompTab.vue?vue&type=script&lang=js"
export * from "./AgencyCompTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__